const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export function normalizeDateInput(value) {
  if (!value) return "";
  if (DATE_ONLY_REGEX.test(value)) {
    return value;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDateOnly(value, fallback = "—") {
  if (!value) return fallback;
  const normalized = normalizeDateInput(value);
  if (!normalized) {
    return typeof value === "string" ? value : fallback;
  }
  const [year, month, day] = normalized.split("-");
  return `${day}/${month}/${year}`;
}
